<template>
  <shark-loader v-if="tournamentsLoading" />
  <router-view v-else />
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TournamentsBase',
  computed: {
    ...mapState(["tournamentsLoading"])
  },
  created() {
    this.$store.dispatch("loadInitialTournamentsData");
  }
}
</script>